/// <amd-module name="Wit/BacklogsHub/Directory/BacklogsDirectoryView" />
import * as React from "react";
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import * as Resources from "Wit/BacklogsHub/Resources";
import { FavoriteTypes } from "Wit/Common/Generated/Constants";
import { DirectoryView } from "Wit/DirectoryView/Components/DirectoryView";
import { Content } from "../Common/BacklogHubContants";
import { IBacklogsDirectoryService } from "../Common/Services/IBacklogsDirectoryService";

export class BacklogsDirectoryView extends VssComponent<{}> {
    private directoryService: IBacklogsDirectoryService;
    public constructor(props: {}, context: IVssComponentContext) {
        super(props, context);

        this.directoryService = context.pageContext.getService<IBacklogsDirectoryService>("IBacklogsDirectoryService");
    }

    public render(): JSX.Element {
        return (
            <DirectoryView
                artifactType={FavoriteTypes.WORK_TEAMBACKLOG}
                directoryItemName={Resources.Backlogs}
                pageTitle={Resources.BacklogsHeader}
                rowIconName="BacklogList"
                directoryService={this.directoryService}
                treeAriaLabel={Resources.BacklogsDirectoryTable}
                zeroDataContributionId={Content.DirectoryZeroDataPng}
            />
        );
    }
}

Components.add("backlogs-directory-view-component", BacklogsDirectoryView);
